<template>
  <div class="w-screen h-screen flex overflow-hidden" style="background-color: #020308">
    <!-- BRANDING (LEFT SIDE) -->
    <div class="hidden xl:block h-screen w-1/2 pl-5 py-5">
      <div class="w-full h-full flex flex-col bg-white overflow-hidden" style="border-radius: 44px;">
        <div class="flex-grow w-full flex flex-col items-center justify-center px-2">
          <!-- Header -->
          <div class="flex flex-col w-full text-center mt-8" style="max-width: 502px">
            <h1 class="main-heading">
              Create your free trial in 30 seconds
            </h1>
            <BaseText type="body" size="md" style="color: #4B5060" class="mt-3">
              Join thousands of businesses who are scaling their creative strategy research & analysis.
            </BaseText>
          </div>
          <!-- Review Card -->
          <div class="w-full flex-grow min-h-0" style="max-height: 64px; min-height: 12px;" />
          <div class="review-card w-full flex gap-9 p-4">
            <img src="https://publicassets.foreplay.co/review-brick-main.png" class="object-cover rounded-2xl flex-shrink-0" 
            style="width: 212px; height: 328px; object-position: 10% 0" />
            <div class="flex-grow flex flex-col">
              <div class="flex flex-col gap-2 mt-5 pr-5">
                <BaseText type="heading" size="md" style="color: #090A0E">
                  $500K/day in Q4 using creative systems built in Foreplay.
                </BaseText>
                <BaseText type="body" size="sm" style="color: #343643">
                  This wasn't a story about chasing vitality or growth hacks. It was about focusing on the levers we knew would have the biggest impact.
                  <br/><br/>
                  And Foreplay was the engine behind the system.
                </BaseText>
              </div>
              <div class="w-full flex items-center justify-between pr-2 mt-auto mb-5">
                <div class="flex items-center gap-3">
                  <img src="https://publicassets.foreplay.co/review-brick-avatar.png" class="object-contain rounded-full" style="width: 40px; height: 40px" />
                  <div class="flex flex-col">
                    <BaseText type="label" size="sm" style="color: #171921">
                      Toby Waller
                    </BaseText>
                    <BaseText type="body" size="sm" style="color: #4B5060">
                      Co-Founder of Brick Social
                    </BaseText>
                  </div>
                </div>
                <svg xmlns="http://www.w3.org/2000/svg" width="71" height="30" viewBox="0 0 1260 480" version="1.1">
                  <path d="M 119.961 65.805 C 105.467 73.087, 77.250 84.325, 55.429 91.509 C 46.215 94.541, 38.075 97.523, 37.339 98.134 C 36.564 98.777, 36 101.248, 36 104.001 C 36 109.350, 36.068 109.400, 47.500 112.583 C 59.705 115.981, 65.494 120.800, 68.706 130.236 C 70.393 135.190, 70.508 143.858, 70.660 277.500 C 70.748 355.600, 70.506 422.326, 70.121 425.781 C 69.735 429.236, 69.663 432.426, 69.960 432.872 C 70.536 433.735, 79.620 437, 81.447 437 C 82.047 437, 87.537 433.909, 93.647 430.131 L 104.756 423.261 117.628 427.535 C 124.708 429.886, 134.775 432.541, 140 433.436 C 153.622 435.769, 176.704 436.566, 187.010 435.059 C 238.837 427.481, 283.631 378.426, 288.425 324 C 289.200 315.199, 287.383 292.674, 285.026 281.877 C 278.238 250.773, 255.421 225.364, 224.958 214.984 C 216.781 212.197, 196.144 211.174, 183.836 212.944 C 167.625 215.275, 152.491 221.591, 141.328 230.683 L 136 235.023 136.014 225.762 C 136.049 201.823, 138.128 126.197, 139.548 97.174 C 140.993 67.648, 140.992 64.637, 139.542 62.424 C 137.026 58.584, 132.926 59.292, 119.961 65.805 M 942 62.666 C 923.669 69.889, 896.014 78.119, 871.944 83.513 C 863.628 85.376, 856.170 87.444, 855.370 88.108 C 854.305 88.992, 853.994 91.079, 854.208 95.906 L 854.500 102.497 860.500 104.786 C 876.107 110.743, 883.343 116.337, 886.148 124.618 C 887.858 129.667, 888.734 397.322, 887.060 403.087 C 885.307 409.119, 882.968 410.428, 872.828 411.051 C 866.563 411.436, 863.588 412.038, 862.947 413.051 C 861.567 415.232, 861.797 427.379, 863.250 429.086 C 864.277 430.292, 866.641 430.446, 876.500 429.945 C 891.807 429.168, 946.947 429.149, 962 429.915 C 976.272 430.641, 977 430.187, 977 420.571 C 977 412.012, 975.928 411, 966.863 411 C 952.713 411, 953 411.993, 953 363.032 C 953 319.942, 952.669 321.939, 959.183 325.750 C 963.813 328.459, 1010.885 392.634, 1016.212 403.500 C 1017.056 405.223, 1017.414 407.564, 1017.052 409 C 1016.533 411.057, 1015.721 411.558, 1012.473 411.825 C 1010.302 412.003, 1007.957 412.621, 1007.263 413.197 C 1005.406 414.738, 1005.544 428.645, 1007.427 429.700 C 1008.212 430.140, 1016.650 430.134, 1026.177 429.687 C 1035.705 429.240, 1061.275 429.157, 1083 429.504 C 1104.725 429.851, 1123.360 430.127, 1124.410 430.117 C 1127.283 430.091, 1127.968 428.209, 1127.985 420.285 C 1128.002 412.166, 1127.077 411, 1120.615 411 C 1115.089 411, 1106.956 408.979, 1101.500 406.251 C 1093.185 402.092, 1075.967 383.007, 1028.765 325.627 L 1004.190 295.754 1010.345 290.033 C 1031.784 270.105, 1055.972 251.026, 1066.500 245.738 C 1075.942 240.996, 1089.270 236.859, 1097 236.272 C 1101.125 235.959, 1104.831 235.207, 1105.235 234.601 C 1106.518 232.678, 1106.112 219.338, 1104.736 218.196 C 1103.864 217.472, 1096.239 217.429, 1080.145 218.058 C 1065.824 218.617, 1046.141 218.604, 1029.159 218.022 C 1006.701 217.254, 1001.312 217.322, 1000.500 218.383 C 999.924 219.136, 999.712 223, 1000 227.489 L 1000.500 235.288 1005.279 236.497 C 1011.068 237.961, 1015 241.392, 1015 244.979 C 1015 250.651, 1003.175 265.791, 982.024 287.200 C 967.674 301.724, 961.911 305.923, 956.250 305.978 L 954 306 954.041 285.750 C 954.138 237.269, 956.016 82.585, 956.621 73.274 C 957.372 61.704, 956.716 59.967, 951.628 60.052 C 949.907 60.081, 945.575 61.257, 942 62.666 M 554.043 105.129 C 541.833 107.175, 530.398 115.418, 525.262 125.875 C 518.134 140.390, 525.444 160.967, 540.652 169.200 C 559.230 179.256, 585.400 171.188, 594.494 152.602 C 605.571 129.961, 591.687 107.041, 565.500 104.741 C 562.200 104.451, 557.044 104.625, 554.043 105.129 M 447 211.276 C 443.425 212.499, 438.250 214.813, 435.500 216.418 C 425.274 222.386, 411.679 238.315, 404.895 252.280 C 403.422 255.310, 401.957 257, 400.801 257 C 399.810 257, 399.005 256.438, 399.011 255.750 C 399.065 249.511, 394.447 216.022, 393.272 214.132 C 390.606 209.845, 385.497 211.421, 345.565 228.849 C 325.251 237.715, 308.197 245.403, 307.667 245.933 C 306.463 247.137, 306.187 251.955, 307.196 254.142 C 307.613 255.044, 311.677 257.963, 316.227 260.628 C 326.590 266.696, 331.510 271.100, 334.485 276.970 C 338.931 285.744, 339.202 290.140, 338.829 347.544 C 338.511 396.432, 338.316 401.800, 336.745 404.689 C 333.717 410.261, 331.721 411, 319.712 411 C 305.194 411, 305 411.131, 305 420.913 C 305 426.032, 305.434 429.073, 306.250 429.670 C 306.978 430.203, 313.759 430.288, 322.500 429.873 C 339.967 429.045, 404.585 429.072, 426.769 429.918 C 435.168 430.238, 442.480 430.350, 443.019 430.167 C 443.561 429.983, 444 425.887, 444 421.024 C 444 413.913, 443.695 412.097, 442.418 411.607 C 441.548 411.273, 435.001 411, 427.869 411 C 412.567 411, 409.831 410.043, 406.943 403.684 C 405.153 399.739, 405.043 396.373, 405.022 344.802 L 405 290.103 407.600 281.802 C 411.715 268.666, 415.426 262.456, 420.684 259.911 C 426.213 257.234, 430.672 257.782, 439.326 262.200 C 444.477 264.829, 446.941 265.425, 454.196 265.796 C 462.262 266.207, 463.358 266.021, 469.347 263.218 C 481.905 257.342, 489.730 245.988, 488.741 235.078 C 487.676 223.333, 480.335 212.915, 471.193 210.176 C 464.895 208.289, 454.324 208.770, 447 211.276 M 546.659 225.924 C 523.096 233.546, 503.383 240.217, 502.852 240.748 C 502.320 241.280, 502.024 244.141, 502.193 247.107 L 502.500 252.500 511.722 257 C 522.319 262.171, 526.412 265.657, 529.332 272 C 531.260 276.188, 531.463 279.203, 532.271 315.500 C 533.255 359.770, 532.646 400.860, 530.931 405.771 C 530.303 407.570, 528.967 409.483, 527.961 410.021 C 526.955 410.559, 520.897 411, 514.500 411 C 508.103 411, 501.998 411.466, 500.934 412.035 C 499.272 412.925, 499 414.184, 499 421 C 499 427.576, 499.299 429.068, 500.750 429.742 C 501.712 430.189, 508.350 430.288, 515.500 429.962 C 534.069 429.115, 590.428 429.036, 610.821 429.828 C 620.348 430.197, 629.010 430.177, 630.071 429.782 C 631.755 429.156, 632 428.052, 632 421.091 C 632 415.811, 631.578 412.845, 630.750 412.309 C 630.063 411.864, 623.922 411.275, 617.104 411 C 604.914 410.508, 604.672 410.453, 602.604 407.677 C 600.504 404.859, 600.500 404.677, 600.270 309.701 C 600.144 257.367, 599.821 213.975, 599.552 213.274 C 598.285 209.973, 589.401 212.098, 546.659 225.924 M 731 213.936 C 714.779 217.362, 699.695 224.710, 685.586 236.060 C 664.671 252.885, 651.314 275.916, 644.844 306.312 C 641.618 321.466, 641.579 349.824, 644.768 362.377 C 649.255 380.041, 659.326 397.280, 673.526 411.601 C 680.313 418.445, 683.183 420.503, 692.029 424.864 C 707.698 432.589, 723.998 435.991, 745.372 435.997 C 777.484 436.006, 812.195 423.787, 831.701 405.605 C 839.075 398.733, 842 394.680, 842 391.338 C 842 389.315, 834.216 381, 832.323 381 C 831.630 381, 827.882 383.057, 823.995 385.572 C 808.962 395.297, 799.489 397.965, 780 397.965 C 764.730 397.965, 756.219 396.275, 746.945 391.402 C 734.064 384.633, 723.674 370.291, 716.228 349 C 710.854 333.636, 709.553 323.349, 709.525 296 C 709.500 271.732, 709.526 271.424, 712.291 263.500 C 719.098 243.991, 732.584 231.853, 745.736 233.399 C 758.578 234.908, 765.703 241.251, 771.059 255.942 C 774.093 264.264, 779.973 273.019, 784.735 276.307 C 792.529 281.688, 797.910 283.411, 807.068 283.457 C 814.673 283.495, 816.298 283.161, 821.534 280.485 C 826.053 278.175, 828.143 276.321, 830.467 272.561 C 833.157 268.207, 833.496 266.797, 833.469 260.077 C 833.375 237.338, 812.097 219.279, 778.619 213.526 C 766.202 211.392, 742.060 211.600, 731 213.936 M 159 248.009 C 153.402 248.973, 143.891 252.294, 139.680 254.758 L 136.500 256.617 136.607 315.059 C 136.725 379.196, 137.090 384.090, 142.627 395.591 C 146.704 404.060, 156.012 413.184, 162.909 415.472 C 172.843 418.767, 187.602 416.010, 198.433 408.837 C 204.807 404.615, 210.383 396.942, 214.606 386.585 C 220.413 372.341, 221.317 365.072, 220.709 337.500 C 220.162 312.713, 218.925 302.497, 214.865 289.241 C 205.816 259.695, 184.127 243.687, 159 248.009 M 1174.650 358.993 C 1162.638 361.147, 1152.089 369.370, 1146.674 380.799 C 1143.767 386.937, 1143.500 388.341, 1143.500 397.500 C 1143.500 406.239, 1143.836 408.216, 1146.160 413.175 C 1155.006 432.043, 1178.603 440.910, 1199.147 433.084 C 1220.579 424.921, 1228.512 397.628, 1215.708 376.109 C 1208.006 363.166, 1190.975 356.066, 1174.650 358.993" 
                  stroke="none" fill="#4B5060" fill-rule="evenodd"/>
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div class="footer relative w-full flex flex-col mt-8">
          <div class="w-full flex items-center justify-center">
            <h2 class="brands-heading">
              Powering +10,000 Social Ad Teams & Agencies
            </h2>
          </div>
          <!-- Brands Scolling Carousel -->
          <div class="scrollers-container flex flex-col">
            <div id="top-scroller" class="scroller-right flex gap-4 w-max">
              <div ref="top-duplicate-content" class="content flex gap-4 items-center" />
              <div ref="top-content" class="content flex gap-4 items-center">
                <div v-for="(brandSrc, index) in carouselBrandImages.top" :key="`top-brand-${index}`" :ref="`top-brand-${index}`">
                  <img :src="brandSrc" class="object-contain" style="width: 120px; height: 60px">
                </div>
              </div>
            </div>
            <div id="bottom-scroller" class="scroller-right flex gap-4 items-center w-max">
              <div ref="bottom-content" class="content flex gap-4 items-center">
                <img v-for="(brandSrc, index) in carouselBrandImages.bottom" :key="`bottom-brand-${index}`" :ref="`bottom-brand-${index}`"
                :src="brandSrc" class="object-contain" style="width: 120px; height: 60px">
              </div>
              <div ref="bottom-duplicate-content" class="content flex gap-4 items-center" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- FORM (RIGHT SIDE) -->
    <div class="h-screen w-full xl:w-1/2 flex xl:items-center xl:justify-center px-5 py-8 xl:py-0 overflow-y-auto">
      <div class="flex flex-col items-center w-full xl:pb-10 my-auto xl:my-0" style="max-width: 400px">
        <!-- Logo -->
        <img src="../../assets/images/foreplay-logo.png" style="width: 136px; height: 40px;" />
        <form class="w-full mt-8 xl:mt-12" @submit.prevent="checkForm">
          <!-- Full Name Input -->
          <BaseText type="label" size="md" class="text-white w-full mb-1">
            Full Name
          </BaseText>
          <div class="input-container w-full flex items-center" :class="{'active': fullName?.length || fullNameInputFocused, 'errored': fullNameError && !fullNameInputFocused}">
            <input v-model="fullName" class="form-input flex-grow min-w-0" placeholder="Zark Muckerberg" type="text"
            @focus="fullNameInputFocused = true" @blur="fullNameInputFocused = false" @input="() => submitAttempted = false" />
            <transition>
              <InfoIcon v-if="!fullNameInputFocused && fullNameError" style="color: #DF1C41" />
            </transition>
          </div>
          <transition name="error">
            <div v-if="fullNameError" class="w-full flex items-end h-7">
              <BaseText type="body" size="sm"class="transition-colors" :style="{ color: fullNameInputFocused ? 'rgba(255, 255, 255, 0.68)' : '#DF1C41' }">
                {{ fullNameError }}
              </BaseText>
            </div>
          </transition>
          <!-- Email Input -->
          <BaseText type="label" size="md" class="text-white w-full mt-4 mb-1">
            Email
          </BaseText>
          <div class="input-container w-full flex items-center" :class="{'active': email?.length || emailInputFocused, 'errored': emailError && !emailInputFocused}">
            <input v-model="email" class="form-input flex-grow min-w-0" placeholder="hello@yourcompany.com" type="email"
            @focus="emailInputFocused = true" @blur="emailInputFocused = false" @input="() => { submitAttempted = false; emailIsDisposable = false }" />
            <transition>
              <InfoIcon v-if="!emailInputFocused && emailError" style="color: #DF1C41" />
            </transition>
          </div>
          <transition name="error">
            <div v-if="emailError" class="w-full flex items-end h-7">
              <BaseText type="body" size="sm" class="transition-colors" :style="{ color: emailInputFocused ? 'rgba(255, 255, 255, 0.68)' : '#DF1C41' }">
                {{ emailError }}
              </BaseText>
            </div>
          </transition>
          <!-- Password Input -->
          <BaseText type="label" size="md" class="text-white w-full mt-4 mb-1">
            Password
          </BaseText>
          <div class="input-container w-full flex items-center mb-2" :class="{'active': password?.length || passwordInputFocused}">
            <input v-model="password" class="form-input flex-grow min-w-0" placeholder="Choose a password" :type="showPassword ? 'text' : 'password'"
            @focus="passwordInputFocused = true" @blur="passwordInputFocused = false" @input="() => submitAttempted = false"/>
            <button class="w-6 h-6 relative flex items-center cursor-pointer flex-shrink-0" style="color: rgba(255, 255, 255, 0.44)" 
            type="button" tabindex="-1" @click="showPassword= !showPassword">
              <transition name="visibility">
                <svg v-if="showPassword" xmlns="http://www.w3.org/2000/svg" key="visible-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" class="h-4">
                  <path d="M9.16536 4.42071C8.76872 4.5401 8.54397 4.95841 8.66335 5.35505C8.78273 5.75169 9.20105 5.97645 9.59768 5.85706L9.16536 4.42071ZM21.529 11.1176L22.1806 10.7462V10.7462L21.529 11.1176ZM19.1413 14.9666C18.8678 15.2776 18.8982 15.7515 19.2092 16.0251C19.5203 16.2986 19.9942 16.2682 20.2677 15.9571L19.1413 14.9666ZM21.5297 12.8811L20.8781 12.5098L20.8781 12.5098L21.5297 12.8811ZM3.28029 2.21967C2.9874 1.92678 2.51253 1.92678 2.21963 2.21967C1.92674 2.51256 1.92674 2.98744 2.21963 3.28033L3.28029 2.21967ZM2.47016 11.1188L3.12179 11.4901H3.12179L2.47016 11.1188ZM20.7196 21.7803C21.0125 22.0732 21.4874 22.0732 21.7803 21.7803C22.0732 21.4874 22.0732 21.0126 21.7803 20.7197L20.7196 21.7803ZM2.47125 12.8829L1.81966 13.2543H1.81966L2.47125 12.8829ZM10.2322 10.2322C10.5251 9.93934 10.5251 9.46447 10.2322 9.17157C9.9393 8.87868 9.46443 8.87868 9.17153 9.17157L10.2322 10.2322ZM14.8284 14.8284C15.1213 14.5355 15.1213 14.0607 14.8284 13.7678C14.5355 13.4749 14.0606 13.4749 13.7677 13.7678L14.8284 14.8284ZM9.59768 5.85706C13.5394 4.67067 17.9939 6.42962 20.8774 11.489L22.1806 10.7462C19.0295 5.21732 13.9174 2.99041 9.16536 4.42071L9.59768 5.85706ZM20.2677 15.9571C20.9622 15.1674 21.6043 14.2652 22.1814 13.2524L20.8781 12.5098C20.3482 13.4398 19.7644 14.258 19.1413 14.9666L20.2677 15.9571ZM20.8774 11.489C21.0579 11.8057 21.058 12.1942 20.8781 12.5098L22.1814 13.2524C22.6242 12.4754 22.6229 11.5222 22.1806 10.7462L20.8774 11.489ZM2.21963 3.28033L5.99934 7.06003L7.06 5.99937L3.28029 2.21967L2.21963 3.28033ZM3.12179 11.4901C4.21375 9.57383 5.53387 8.13258 6.95695 7.14609L6.10238 5.91332C4.47301 7.04281 3.00749 8.66097 1.81853 10.7475L3.12179 11.4901ZM5.99934 7.06003L16.9399 18.0006L18.0005 16.9399L7.06 5.99937L5.99934 7.06003ZM16.9399 18.0006L20.7196 21.7803L21.7803 20.7197L18.0005 16.9399L16.9399 18.0006ZM1.81966 13.2543C3.74764 16.6368 6.40542 18.7894 9.29529 19.6173C12.1917 20.4471 15.2481 19.9232 17.8975 18.0866L17.0429 16.8539C14.7434 18.4479 12.1496 18.8747 9.7084 18.1753C7.26065 17.4741 4.8934 15.6178 3.12283 12.5115L1.81966 13.2543ZM1.81853 10.7475C1.37557 11.5249 1.37752 12.4786 1.81966 13.2543L3.12283 12.5115C2.94218 12.1946 2.9421 11.8055 3.12179 11.4901L1.81853 10.7475ZM12 14.5C10.6192 14.5 9.49996 13.3807 9.49996 12H7.99996C7.99996 14.2091 9.79082 16 12 16V14.5ZM9.49996 12C9.49996 11.3094 9.77896 10.6855 10.2322 10.2322L9.17153 9.17157C8.4485 9.89461 7.99996 10.8956 7.99996 12H9.49996ZM13.7677 13.7678C13.3145 14.221 12.6905 14.5 12 14.5V16C13.1043 16 14.1054 15.5515 14.8284 14.8284L13.7677 13.7678Z"
                  fill="currentColor" />
                </svg>
                <svg v-else-if="password?.length" xmlns="http://www.w3.org/2000/svg" key="hide-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" class="h-4">
                  <path d="M2.47032 11.1187L1.81869 10.7474H1.81869L2.47032 11.1187ZM21.5298 11.1188L22.1814 10.7475V10.7475L21.5298 11.1188ZM2.47032 12.8811L1.81869 13.2524H1.81869L2.47032 12.8811ZM21.5298 12.8812L22.1814 13.2526V13.2526L21.5298 12.8812ZM3.12194 11.49C5.43733 7.42677 8.76885 5.49998 12 5.5C15.2312 5.50002 18.5627 7.42687 20.8781 11.4901L22.1814 10.7475C19.6579 6.31907 15.8791 4.00003 12 4C8.12093 3.99997 4.34216 6.31896 1.81869 10.7474L3.12194 11.49ZM1.81869 13.2524C4.34216 17.6809 8.12092 19.9999 12 19.9999C15.8791 20 19.6579 17.681 22.1814 13.2526L20.8781 12.5099C18.5627 16.5732 15.2312 18.5 12 18.4999C8.76886 18.4999 5.43733 16.5731 3.12194 12.5098L1.81869 13.2524ZM1.81869 10.7474C1.37619 11.5239 1.37619 12.4759 1.81869 13.2524L3.12194 12.5098C2.94177 12.1936 2.94177 11.8062 3.12194 11.49L1.81869 10.7474ZM20.8781 11.4901C21.0583 11.8063 21.0583 12.1937 20.8781 12.5099L22.1814 13.2526C22.6239 12.476 22.6239 11.524 22.1814 10.7475L20.8781 11.4901ZM14.5 12C14.5 13.3807 13.3807 14.5 12 14.5V16C14.2092 16 16 14.2091 16 12H14.5ZM12 14.5C10.6193 14.5 9.50004 13.3807 9.50004 12H8.00004C8.00004 14.2091 9.7909 16 12 16V14.5ZM9.50004 12C9.50004 10.6193 10.6193 9.5 12 9.5V8C9.7909 8 8.00004 9.79086 8.00004 12H9.50004ZM12 9.5C13.3807 9.5 14.5 10.6193 14.5 12H16C16 9.79086 14.2092 8 12 8V9.5Z"
                  fill="currentColor" />
                </svg>
              </transition>
            </button>
          </div>
          <ValidationVisualizer 
            :value="password"
            :validation-requirements="validationRequirements"
            :is-valid.sync="passwordValid"
            :show-validator="!!(password?.length) || submitAttempted"
            :top-padding="0"
            :bottom-padding="8"
          />
          <!-- Sign In Button -->
          <button class="submit-button w-full mt-4 p-2 h-10 flex items-center justify-center transition duration-200"
          :class="submitDisabled ? 'disabled' : 'bg-white bg-opacity-100 hover:bg-opacity-90'"
          type="submit" :disabled="loadingEmailLink" :loading="loadingEmailLink">
            <BaseLoadingSpinnerCircle v-if="loadingEmailLink" :duration="1" />
            <BaseText v-else type="heading" size="sm">
              Start your 7-day free trial
            </BaseText>
          </button>
          <!-- reCAPTCHA -->
          <transition name="recaptcha">
            <div v-show="showRecaptcha" class="relative w-full" style="height: 102px">
              <div
                id="recaptcha-container"
                ref="recaptchaContainer"
                class="pt-6 w-full flex justify-center"
              />
            </div>
          </transition>
        </form>
        <!-- Alternative Route Link -->
        <div class="w-full flex items-center justify-center gap-1.5 mt-6">
          <BaseText type="body" size="sm" class="text-neutral-alpha-650">
            Do you have an account?
          </BaseText>
          <router-link to="/login" class="text-neutral-alpha-700 transition-colors duration-100 hover:text-white">
            <BaseText type="label" size="sm">
              Sign in
            </BaseText>
          </router-link>
        </div>
        <!-- Divider -->
        <div class="w-full flex items-center gap-6 py-1 mt-6">
          <div class="flex-grow h-0 border-t border-neutral-alpha-50" />
          <BaseText type="body" size="sm" class="text-neutral-alpha-650">
            or
          </BaseText>
          <div class="flex-grow h-0 border-t border-neutral-alpha-50" />
        </div>
        <!-- Google Sign In Button -->
        <button class="google-btn w-full flex items-center justify-center gap-3 p-2 mt-4"
        @click="loginUserWithGoogle">
          <img src="../../assets/images/google-logo.png" class="w-5 h-5" style="opacity: 0.68">
          <BaseText type="heading" size="sm" class="text-white">
            Sign up with Google
          </BaseText>
        </button>
        <!-- Disclaimer -->
        <BaseText type="body" size="sm" class="w-full text-center text-neutral-alpha-650 mt-5" style="max-width: 360px">
          By clicking one of the buttons above, you agree to our <a
            href="https://www.foreplay.co/page/terms-of-service"
            target="_blank"
            class="font-semibold text-neutral-alpha-700 transition-colors duration-200 hover:text-white"
          > Terms and Conditions </a> and <a
            href="https://www.foreplay.co/page/privacy-policy"
            target="_blank"
            class="font-semibold text-neutral-alpha-700 transition-colors duration-200 hover:text-white"
          > Privacy Policy</a>
        </BaseText>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import foreplayAPI from '@/api/foreplayServer'
import store from '../../store'
import firebase from '@/api/config/FirebaseConfig'
import disposableEmailBlocklist from '../../utils/disposableEmailBlocklist'

import ValidationVisualizer from '../../components/account/ValidationVisualizer.vue'
import InfoIcon from '../../components/globals/Icons/InfoSimpleIcon.vue'

export default {
  name: 'SignUpView',
  components: {
    ValidationVisualizer,
    InfoIcon
  },
  data () {
    const carouselBrandImages = {
      top: [
        'https://publicassets.foreplay.co/carousel-brands/hello-fresh.png',
        'https://publicassets.foreplay.co/carousel-brands/canva.png',
        'https://publicassets.foreplay.co/carousel-brands/ag1.png',
        'https://publicassets.foreplay.co/carousel-brands/true-classic.png',
        'https://publicassets.foreplay.co/carousel-brands/ridge.png',
        'https://publicassets.foreplay.co/carousel-brands/paramount.png',
        'https://publicassets.foreplay.co/carousel-brands/click-funnels.png'
      ],
      bottom: [
        'https://publicassets.foreplay.co/carousel-brands/pearmill.png',
        'https://publicassets.foreplay.co/carousel-brands/common-thread.png',
        'https://publicassets.foreplay.co/carousel-brands/vayner-media.png',
        'https://publicassets.foreplay.co/carousel-brands/lunar.png',
        'https://publicassets.foreplay.co/carousel-brands/growth-collective.png',
        'https://publicassets.foreplay.co/carousel-brands/klient-boost.png',
        'https://publicassets.foreplay.co/carousel-brands/dentsu.png'
      ]
    }

    const validationRequirements = [
      {
        label: 'At least 8 characters.',
        validator: (password) => password?.length && password.length >= 8,
      },
      {
        label: 'At least 1 number.',
        validator: (password) => /[0-9]/.test(password),
      },
      {
        label: 'At least 1 uppercase letter.',
        validator: (password) => /[A-Z]/.test(password),
      }
    ]

    return {
      // Form
      fullName: null,
      email: null,
      password: null,
      showPassword: false,
      emailIsDisposable: false,
      passwordValid: false,
      validationRequirements,

      // reCAPTCHA
      recaptchaVerified: false,
      recaptchaVerifier: null,
      recaptchaWidgetId: null,
      recaptchaSetupDone: false,
      
      // UI
      loadingEmailLink: false,
      submitAttempted: false,
      carouselBrandImages,
      fullNameInputFocused: false,
      emailInputFocused: false,
      passwordInputFocused: false,

      // Analytics
      timeoutId: null
    }
  },
  computed: {
    submitDisabled () {
      return this.loadingEmailLink || !this.recaptchaVerified || this.hasErrors || !this.fullName?.length || !this.email?.length || !this.password?.length
    },
    fullNameError () {
      return this.submitAttempted && !this.fullName?.length ? 'Full Name required.' : null
    },
    emailError () {
      if (!this.email?.length) {
        return this.submitAttempted ? 'Email required.' : null
      }
      const emailRegex = /^[^\s@]+@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}$/;
      if (!emailRegex.test(this.email) || this.emailIsDisposable) return 'Please enter a valid email address.'

      return null
    },
    hasErrors () {
      return this.fullNameError || this.emailError || !this.passwordValid
    },
    showRecaptcha () {
      return this.fullName?.length && this.email?.length && this.password?.length && !this.hasErrors
    }
  },
  async mounted () {
    window.Intercom('boot', {
      app_id: process.env.VUE_APP_INTERCOM_ID,
      hide_default_launcher: true
    })
    window.Intercom('hide')
    // get utm_source, utm_medium, utm_campaign from store
    const utmSource = store.getters['MiscModule/getUtmSource']
    const utmMedium = store.getters['MiscModule/getUtmMedium']
    const utmCampaign = store.getters['MiscModule/getUtmSource']
    clearTimeout(this.timeoutId)
    this.timeoutId = setTimeout(() => {
      window.analytics.page('SignUp Page Viewed', {
        pathname: window.location.pathname,
        path: window.location.pathname,
        referrer: window.location.href,
        utmCampaign: utmCampaign || '',
        utmSource: utmSource || '',
        utmMedium: utmMedium || ''

      })
    }, 5000)

    this.$nextTick(() => {
      this.duplicateScrollerRowContent('top')
      this.duplicateScrollerRowContent('bottom')
    })
  },
  watch: {
    showRecaptcha (visible) {
      if (visible && !this.recaptchaSetupDone) {
        this.$nextTick(() => {
          this.setupRecaptcha()
          this.recaptchaSetupDone = true
        })
      }
    }
  },
  beforeDestroy () {
    window.Intercom('update', {
      hide_default_launcher: false
    })
    // Reset recaptcha if it exists
    if (this.recaptchaVerifier) {
      this.recaptchaVerifier.clear()
    }
  },
  methods: {
    ...mapActions('AuthModule', ['loginUserWithGoogle', 'signUpWithEmailAndPassword']),
    setupRecaptcha () {
      // Initialize reCAPTCHA verifier
      this.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container', {
        size: 'normal',
        callback: (response) => {
          // reCAPTCHA solved, allow signUp
          this.recaptchaVerified = true
        },
        'expired-callback': () => {
          // Reset reCAPTCHA
          this.recaptchaVerified = false
        }
      })
      // Render the reCAPTCHA widget
      this.recaptchaWidgetId = this.recaptchaVerifier.render()
    },
    // Send Email Link
    async checkForm (e) {
      this.submitAttempted = true
      if (!this.submitDisabled) {
        await this.signUpUser()
      }

      e.preventDefault()
    },
    async attemptSignup () {
      try{
        const attemptPayload = {
          email: this.email,
        }
        const signUpResult = await foreplayAPI.Users.validateSignup(attemptPayload)
        if (signUpResult.error) {
          this.$showAlert({
            type: 'error',
            message: signUpResult.message
          })
          return false
        }
        return true
      } catch (e) {
        console.error(e.response)
        const errMessage = e.response?.data?.message || 'Unable to process your request. Think this is an error? Contact support.'
        this.$showAlert({
          message: errMessage,
          type: 'error'
        })
        return false
      }
    },
    async signUpUser () {
      this.loadingEmailLink = true

      try {
        // Check that the email is not part of the disposable email blocklist
        const emailDomain = this.email.split('@')[1]
        if (disposableEmailBlocklist.has(emailDomain)) {
          this.emailIsDisposable = true
          throw new Error('Disposable email addresses are not allowed.')
        }

        const canSignup = await this.attemptSignup()
        if (!canSignup) {
          this.recaptchaVerified = false
          this.recaptchaVerifier?.reset(this.recaptchaWidgetId)
          return
        }

        const payload = {
          email: this.email,
          password: this.password,
          name: this.fullName,
          recaptchaToken: await this.recaptchaVerifier.verify()
        }

        payload.firstName = this.fullName.split(' ')[0]
        if (this.fullName.split(' ')[1]) {
          payload.lastName = this.fullName.split(' ')[1]
        }
        await this.signUpWithEmailAndPassword(payload)
      } catch (e) {
        console.log(e)
        this.$showAlert({
          message: e.message,
          type: 'error'
        })
        // Reset reCAPTCHA on error
        this.recaptchaVerified = false
        this.recaptchaVerifier.reset(this.recaptchaWidgetId)
      } finally {
        this.loadingEmailLink = false
      }
    },
    // ===== UI METHODS =====
    duplicateScrollerRowContent (row) {
      const rowElms = []
      for (let i = 0; i < 7; i++) {
        const ref = this.$refs[`${row}-brand-${i}`]?.[0]
        if (ref) rowElms.push(ref)
      }
      rowElms.forEach(elm => {
        const clonedElm = elm.cloneNode(true)
        this.$refs[`${row}-duplicate-content`].appendChild(clonedElm)
      })
    }
  },
  metaInfo: {
    title: 'Create Your Foreplay Account | Foreplay.co',
    link: [
      { rel: 'canonical', href: 'https://app.foreplay.co/sign-up' }
    ]
  }
}
</script>

<style scoped>
.main-heading {
  /* Display/H4 */
  font-family: Inter;
  font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: 36px; /* 128.571% */
  letter-spacing: -0.197px;
}
.review-card {
  border-radius: 32px;
  max-width: 644px;
  background-color: #F9F9FA;
}
.brands-heading {
  color: #343643;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 550;
  line-height: 20px; /* 166.667% */
  letter-spacing: 1px;
  text-transform: uppercase;
}
.scrollers-container {
  position: absolute;
  height: 132px;
  width: 936px;
  top: 48px;
  left: 50%;
  transform: translateX(-50%);
  overflow: hidden;
  mask-image: 
    linear-gradient(to right, transparent, black 12px, black),
    linear-gradient(to left, transparent, black 12px, black);
  mask-composite: intersect;
}

/* Scrollers */
.footer {
  height: 20%;
  min-height: 180px;
  max-height: 220px;
  margin-bottom: 24px;
}
#top-scroller {
  position: absolute;
  right: 0;
  top: 0;
}
#top-scroller .content {
  animation-name: scrollToRight;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-duration: 120s;
}
#bottom-scroller {
  position: absolute;
  left: 0;
  top: 72px;
}
@media (max-height: 800px) {
  #bottom-scroller {
    display: none;
  }
  .footer {
    height: auto;
    min-height: 120px;
    margin-bottom: 8px;
  }
  .scrollers-container {
    height: 72px;
  }
}
#bottom-scroller .content {
  animation-name: scrollToLeft;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-duration: 120s;
}
@keyframes scrollToRight {
  from { transform: translateX(0); }
  to { 
    /* Account for flex gap by adding 1 rem */
    transform: translateX(calc(100% + 1rem)); 
  }
}
@keyframes scrollToLeft {
  from { transform: translateX(0); }
  to { transform: translateX(calc(-100% - 0.75rem)); }
}

.submit-button {
  background-color: rgba(255, 255, 255, 1);
  color: #13151A;
  border-radius: 10px;
  box-shadow: none;
  transition: background-color 150ms ease-in-out, color 150ms ease-in-out, box-shadow 150ms ease-in-out;
}
.submit-button:hover {
  background-color: rgba(255, 255, 255, 0.9);
}
.submit-button.disabled, .submit-button.disabled:hover {
  background-color: transparent;
  color: rgba(255, 255, 255, 0.32);
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.1);
  cursor: default;
}

.google-btn {
  border: 1px solid;
  border-color: rgba(255, 255, 255, 0.16);
  background-color: transparent;
  border-radius: 10px;
  transition: border-color 150ms ease-in-out, background-color 150ms ease-in-out;
}
.google-btn:hover {
  border-color: transparent;
  background-color: rgba(255, 255, 255, 0.08);
}

/* Inputs */
.input-container {
  background-color: rgba(255, 255, 255, 0.10);
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.10);
  border-radius: 10px;
  padding: 8px 14px;
  display: flex;
  align-items: center;
  transition: background-color 150ms ease-in-out, box-shadow 150ms ease-in-out;
}
.input-container:hover {
  background-color: rgba(255, 255, 255, 0.16);
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.16);
}
.input-container.active, .input-container.active:hover {
  background-color: transparent;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.10);
}
.input-container.errored, .input-container.active.errored, .input-container.active.errored:hover {
  background-color: transparent;
  box-shadow: 0 0 0 1px #F4003A;
}

.form-input {
  background-color: transparent;
  color: white;
  caret-color: white;
  max-width: none;
  font-weight: 300;
  font-size: 16px;
  line-height: 24px;

  /* Reset default styles */
  -webkit-appearance: none;  /* Remove default styling in WebKit browsers */
  -moz-appearance: none;     /* Remove default styling in Firefox */
  appearance: none;          /* Remove default styling in modern browsers */
  padding: 0;
  margin: 0;
  border: none;
  font-size: inherit;
  outline: none;

  /* This is because browsers want to force their ugly styling on you when autofill is triggered. */
  /* This is the only way to prevent that, since they use !important in their overrides. */
  transition:
    color 99999999s step-end,
    background-color 99999999s step-end;
}
.form-input:focus {
  outline: none;
  border: none;
  box-shadow: none;
}
.form-input::placeholder {
  transition: color 200ms ease-in-out;
  color: rgba(255, 255, 255, 0.44);
}
.form-input:focus::placeholder {
  color: rgba(255, 255, 255, 0.2);
}

/* Override browser autofill styles */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  -webkit-text-fill-color: white !important;
}

/* Firefox autocomplete */
.form-input:-moz-autofill {
  color: white !important;
}

/* General autocomplete prevention */
.form-input:autofill {
  color: white !important;
}

.visibility-enter-active, .visibility-leave-active {
  transition: opacity 75ms ease-in-out;
  position: absolute;
  right: 0px;
  top: 4px;
}
.visibility-enter-from, .visiblity-enter, .visibility-leave-to {
  opacity: 0;
}
.visibility-enter-to, .visibility-leave-from {
  opacity: 1;
}
.v-enter-active, .v-leave-active {
  transition: opacity 75ms ease-in-out;
}
.v-enter-from, .v-enter, .v-leave-to {
  opacity: 0;
}
.v-enter-to, .v-leave-from {
  opacity: 1;
}
.error-enter-active {
  animation: errorEnter 75ms ease-in-out forwards;
}
.error-leave-active {
  animation: errorLeave 75ms ease-in-out forwards;
}
@keyframes errorEnter {
  0% { height: 0px; opacity: 0; }
  50% { opacity: 0; }
  100% { height: 28px; opacity: 1; }
}
@keyframes errorLeave {
  0% { height: 28px; opacity: 1; }
  50% { opacity: 0; }
  100% { height: 0px; opacity: 0; }
}

.recaptcha-enter-active {
  animation: recaptchaEnter 500ms ease-in-out 300ms forwards;
  animation-fill-mode: backwards;
}
.recaptcha-leave-active {
  animation: recaptchaLeave 500ms ease-in-out forwards;
}
@keyframes recaptchaEnter {
  0% { height: 0px; opacity: 0; }
  50% { height: 102px; opacity: 0; }
  100% { height: 102px; opacity: 1; }
}
@keyframes recaptchaLeave {
  0% { height: 102px; opacity: 1; }
  50% { height: 102px; opacity: 0; }
  100% { height: 0px; opacity: 0; }
}
</style>